export default __webpack_public_path__ + "src/assets/lend-logo.f4b53f9ad24355a5134b82f1c296e9a6.png";